// 更改某个商品折扣
var $=jQuery;
$(function() {
    // google弹窗
    jQuery(".last-product-title .product-title").off("click").on("click",function(){
      if (window.tab_change) {
        window.tab_change($(this));
      }
    })
  $('.product2 ul li').each(function(){
      if($(this).data("id")=='7743593316594'){
        $(this).find('.price span .money').text('$109.00');
      }
      if($(this).data("id")=='7912079655154'){
        $(this).find('.price span .money').text('$99.00');
      }
    
  })
})